import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class B2BParametrizacoesValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, paleta, refs) {
        let validated = true;

        if (!model.b2bNome) {
            refs.nomeInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'necessario-nome-loja-sovis', true))
        }

        if (!paleta) {
            refs.paletaInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'necessario-padrao-cores', true))
        }

        return validated;
    }

}